import classNames from 'classnames';
import { autobind } from 'core-decorators';
import PropTypes from 'prop-types';
import { Component } from 'react';
import { range } from '/@/utils';
import styles from './styles.module.css';

@autobind
export default class Dots extends Component {
    static propTypes = {
        single: PropTypes.bool,
        max: PropTypes.oneOf([4, 5, 9]).isRequired,
        value: PropTypes.number,
        theme: PropTypes.string,
        reference: PropTypes.bool,
        showValues: PropTypes.bool,
        monochrome: PropTypes.bool,
        reverse: PropTypes.bool,
        rootCenter: PropTypes.bool,
    };

    static contextTypes = {
        theme: PropTypes.string,
    };

    render() {
        const { max, value, reference, monochrome, showValues, theme, reverse, rootCenter } = this.props;
        const order = reverse ? range(max).reverse() : range(max);

        return (
            <div
                className={classNames(styles.root, { [styles.reference]: reference, [styles.rootCenter]: rootCenter })}
            >
                {order.map((index) => {
                    const number = index + 1;
                    const selected = number === value;
                    const extra = (!value && !reference) || number > value;
                    return (
                        <div
                            key={number}
                            className={classNames(
                                styles.dot,
                                // TODO: no quitar este comentario por si se quiere volver atras con el cambio de los colores
                                // styles[this.context.theme],
                                // styles[theme],
                                styles[`dot-${max}`],
                                {
                                    [styles.monochrome]: monochrome,
                                    [styles.selected]: selected,
                                    [styles.extra]: extra,
                                }
                            )}
                        >
                            {showValues && (selected || reference) && number}
                        </div>
                    );
                })}
            </div>
        );
    }
}
